export default __webpack_public_path__ + "static/media/error.78fb0754.svg";